import { render, staticRenderFns } from "./AprobarCreditosSMS.vue?vue&type=template&id=93f6b0f4"
import script from "./AprobarCreditosSMS.vue?vue&type=script&lang=js"
export * from "./AprobarCreditosSMS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports